import React, { useEffect, useState } from 'react';
import { folderManagementServices } from '../../APIServices/folderManagementServices';
import { useToast } from '../../hooks/useToast';

function DeleteFolder({ getFolderManagementData, setModalOpen, folderData}) {
  const toast = useToast();
  const [buttonLoader, setButtonLoader] = useState(false);
  const [designation, setFolder] = useState("");

  const softDeleteRestoreUserFolder = async () => {
    setButtonLoader(true);
    try {
      let userData = {};
      userData.uniqueId = folderData?.uniqueId;
      let data = await folderManagementServices.deleteFolderManagementData(
        userData
      );
      if (data?.statusCode === 200) {
        toast(data?.customMessage || 'Folder deleted successfully.', 'ok');
        getFolderManagementData();
        setModalOpen("");
      } else {
        toast(data?.customMessage || 'Unable to delete folder.', 'warn');
      }
    } catch (error) {
      toast('Unable to delete folder. Please try again.', 'warn');
    } finally {
      setButtonLoader(false);
    }
  }

  return (
    <div
      className="modal-backdrop"
      onClick={() =>
        setModalOpen("")
      }
    >
      <div
        className="modal"
        style={{ maxWidth: 480 }}
        onClick={(e) =>
          e.stopPropagation()
        }
      >
        <div className="modal-head">
          <div>
            <div className="modal-title">
              Delete Folder
            </div>

            <div className="xs muted">
              Delete Folder Details
            </div>
          </div>

          <button
            className="icon-btn"
            onClick={() =>
              setModalOpen("")
            }
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-foot">
          <button
            className="btn btn-ghost"
            onClick={() => setModalOpen("")}
          >
            Cancel
          </button>
          <button
            className="btn btn-danger d-flex align-items-center justify-content-center gap-2"
            onClick={() => softDeleteRestoreUserFolder()}
            disabled={buttonLoader}
          >
            {buttonLoader ? (
              <>
                <div className="buttonLoader"></div>
                <span>Deleting...</span>
              </>
            ) : (
              <>
                <i className="ti ti-check"></i>
                <span>Yes, Delete It!</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteFolder;
